import {
  selectCurrentToken,
  selectCurrentUser,
} from "@/Redux/features/auth/authSlice.js";
import Layout from "../components/common/Layout/Layout.jsx";
import { useSelector } from "react-redux";
import { useRouter } from "next/router.js";
import Image from "next/image.js";
import pic4 from "../assets/demo.png";
import { FaLongArrowAltRight } from "react-icons/fa";
import {
  useGetAllPodcastQuery,
  useMostLikePodcastQuery,
  useMostViewPodcastQuery,
  useRecommendationPodcastQuery,
} from "@/Redux/features/podcast/podcastApi.js";
import TrendingTopic from "@/components/common/TrendingTopic/TrendingTopic.jsx";
import section from "../assets/mic.webp";
import CarouselOne from "@/components/common/Carousels/CarouselOne.jsx";
import CarouselTwo from "@/components/common/Carousels/CarouselTwo.jsx";
import Loading from "@/components/common/loading/index.jsx";
import {
  useGetAllCategoryQuery,
  useGetSingleCategoryQuery,
  useGetTopCategoryQuery,
} from "@/Redux/features/category/categoryApi.js";
import { formatCount } from "@/utilies/CountPositiveComments.js";

const Home = () => {
  const user = useSelector((state) => state.auth.user);
  console.log(user, 'user from home page')
  const router = useRouter();

  //==============get top all category=====================
  const { data: category } = useGetTopCategoryQuery();

  const firstCategory = category?.category[0];
  const secondCategory = category?.category[1];

  //============================ get 1st category data =========================
  const {
    data: firstCategoryPodcast,
    isLoading: firstCategoryPodcastLoading,
    isFetching: firstCategoryPodcastFetch,
  } = useGetSingleCategoryQuery(firstCategory?._id);
  const topOneCategoryPodcast = firstCategoryPodcast?.podcast?.slice(0, 10);

  //============================ get 2nd category data =========================
  const {
    data: secondCategoryPodcast,
    isLoading: secondCategoryPodcastLoading,
    isFetching: secondCategoryPodcastFetch,
  } = useGetSingleCategoryQuery(secondCategory?._id);
  const topTwoCategoryPodcast = secondCategoryPodcast?.podcast?.slice(0, 8);

  //============================  recommendation Podcast =====================================
  const {
    data: recommendationPodcast,
    isLoading,
    isFetching,
  } = useRecommendationPodcastQuery();
  const recommendationPodcasts = recommendationPodcast?.recommendations?.slice(
    0,
    3
  );

  // console.log(countryCategory);
  return (
    <Layout pageTitle="Softex Solution | Podcast">
      {isLoading ||
        isFetching ||
        firstCategoryPodcastLoading ||
        firstCategoryPodcastFetch ||
        secondCategoryPodcastLoading ||
        (secondCategoryPodcastFetch && <Loading />)}
      <section className=" max-w-screen-xl mx-auto ">
        <CarouselOne />

        <p className="text-3xl md:text-4xl lg:text-6xl font-bold text-center text-blue-600 my-10 md:my-0 md:mt-10">
          Featured Shows.
        </p>

        <CarouselTwo recommendationPodcast={recommendationPodcast} />

        <div className="relative p-1 my-10">
          <p className="text-2xl md:text-3xl md:text-center text-blue-600 font-bold">
            {firstCategory?.name}
          </p>

          <button
            onClick={() => router.push(`/category?id=${firstCategory?._id}`)}
            className="absolute font-semibold flex gap-2 top-0 right-0 uppercase px-3 py-1 md:px-6 md:py-2 border border-black rounded-[50px] dark:text-white dark:border-white"
          >
            View All <FaLongArrowAltRight className="my-auto" />
          </button>
        </div>

        <div className="md:grid md:grid-cols-2 lg:grid-cols-4 gap-2 my-5 dark:text-white">
          <div className="md:col-span-2 my-auto p-2">
            <div className=" text-blue-800 uppercase md:text-[48px] font-bold ">
              The
              <p className="flex mt-3">
                p
                <svg
                  className="hidden md:block mt-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="51"
                  height="51"
                  viewBox="0 0 51 51"
                  fill="none"
                >
                  <path
                    d="M40.6298 19.3799C39.8011 19.3799 39.1423 20.0386 39.1423 20.8674V24.2249C39.1423 31.7474 33.0223 37.8674 25.4998 37.8674C17.9773 37.8674 11.8573 31.7474 11.8573 24.2249V20.8461C11.8573 20.0174 11.1986 19.3586 10.3698 19.3586C9.54107 19.3586 8.88232 20.0174 8.88232 20.8461V24.2036C8.88232 32.8524 15.5336 39.9711 24.0123 40.7361V45.2624C24.0123 46.0911 24.6711 46.7499 25.4998 46.7499C26.3286 46.7499 26.9873 46.0911 26.9873 45.2624V40.7361C35.4448 39.9924 42.1173 32.8524 42.1173 24.2036V20.8461C42.108 20.4565 41.9476 20.0858 41.6701 19.8122C41.3925 19.5387 41.0195 19.3836 40.6298 19.3799Z"
                    fill="url(#paint0_linear_2_5096)"
                  />
                  <path
                    d="M25.4955 4.25C20.3105 4.25 16.103 8.4575 16.103 13.6425V24.5225C16.103 29.7075 20.3105 33.915 25.4955 33.915C30.6805 33.915 34.888 29.7075 34.888 24.5225V13.6425C34.888 8.4575 30.6805 4.25 25.4955 4.25ZM28.2793 19.0187C28.1305 19.5712 27.6418 19.9325 27.0893 19.9325C26.983 19.9325 26.8768 19.9112 26.7705 19.89C25.9418 19.6562 25.0705 19.6562 24.2418 19.89C23.5618 20.0812 22.903 19.6775 22.733 19.0187C22.5418 18.36 22.9455 17.68 23.6043 17.51C24.858 17.17 26.1755 17.17 27.4293 17.51C28.0668 17.68 28.4493 18.36 28.2793 19.0187ZM29.4055 14.8963C29.3178 15.135 29.1584 15.3408 28.9492 15.4853C28.7399 15.6299 28.4911 15.7062 28.2368 15.7037C28.088 15.7037 27.9605 15.6825 27.8118 15.64C26.3243 15.0875 24.6668 15.0875 23.1793 15.64C22.8692 15.75 22.5283 15.7336 22.2301 15.5945C21.932 15.4553 21.7005 15.2045 21.5855 14.8963C21.3518 14.2588 21.6918 13.5363 22.3293 13.3237C24.3746 12.58 26.6165 12.58 28.6618 13.3237C29.2993 13.5575 29.6393 14.2588 29.4055 14.8963Z"
                    fill="url(#paint1_linear_2_5096)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_2_5096"
                      x1="5.84643"
                      y1="23.6195"
                      x2="51.2982"
                      y2="29.6728"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FF9447" />
                      <stop offset="0.358383" stopColor="#FF64C1" />
                      <stop offset="0.65524" stopColor="#925EFF" />
                      <stop offset="1" stopColor="#1A1EFF" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_2_5096"
                      x1="14.3871"
                      y1="8.86456"
                      x2="40.4072"
                      y2="10.6731"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FF9447" />
                      <stop offset="0.358383" stopColor="#FF64C1" />
                      <stop offset="0.65524" stopColor="#925EFF" />
                      <stop offset="1" stopColor="#1A1EFF" />
                    </linearGradient>
                  </defs>
                </svg>
                <svg
                  className="md:hidden md:mt-1"
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    d="M19.9165 9.49992C19.5103 9.49992 19.1873 9.82284 19.1873 10.2291V11.8749C19.1873 15.5624 16.1873 18.5624 12.4998 18.5624C8.81234 18.5624 5.81234 15.5624 5.81234 11.8749V10.2187C5.81234 9.81242 5.48942 9.4895 5.08317 9.4895C4.67692 9.4895 4.354 9.81242 4.354 10.2187V11.8645C4.354 16.1041 7.61442 19.5937 11.7707 19.9687V22.1874C11.7707 22.5937 12.0936 22.9166 12.4998 22.9166C12.9061 22.9166 13.229 22.5937 13.229 22.1874V19.9687C17.3748 19.6041 20.6457 16.1041 20.6457 11.8645V10.2187C20.6411 10.0277 20.5625 9.84596 20.4264 9.71186C20.2904 9.57775 20.1075 9.50176 19.9165 9.49992Z"
                    fill="url(#paint0_linear_23_13035)"
                  />
                  <path
                    d="M12.4977 2.0835C9.95605 2.0835 7.89355 4.146 7.89355 6.68766V12.021C7.89355 14.5627 9.95605 16.6252 12.4977 16.6252C15.0394 16.6252 17.1019 14.5627 17.1019 12.021V6.68766C17.1019 4.146 15.0394 2.0835 12.4977 2.0835ZM13.8623 9.32308C13.7894 9.59391 13.5498 9.771 13.279 9.771C13.2269 9.771 13.1748 9.76058 13.1227 9.75016C12.7165 9.63558 12.2894 9.63558 11.8831 9.75016C11.5498 9.84391 11.2269 9.646 11.1436 9.32308C11.0498 9.00016 11.2477 8.66683 11.5706 8.5835C12.1852 8.41683 12.8311 8.41683 13.4456 8.5835C13.7581 8.66683 13.9456 9.00016 13.8623 9.32308ZM14.4144 7.30225C14.3714 7.41927 14.2933 7.52014 14.1907 7.59101C14.0881 7.66187 13.9661 7.69928 13.8415 7.69808C13.7686 7.69808 13.7061 7.68766 13.6331 7.66683C12.904 7.396 12.0915 7.396 11.3623 7.66683C11.2103 7.72073 11.0432 7.71271 10.897 7.6445C10.7509 7.5763 10.6374 7.45337 10.5811 7.30225C10.4665 6.98975 10.6331 6.63558 10.9456 6.53141C11.9482 6.16683 13.0472 6.16683 14.0498 6.53141C14.3623 6.646 14.529 6.98975 14.4144 7.30225Z"
                    fill="url(#paint1_linear_23_13035)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_23_13035"
                      x1="2.86582"
                      y1="11.5782"
                      x2="25.1461"
                      y2="14.5455"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FF9447" />
                      <stop offset="0.358383" stopColor="#FF64C1" />
                      <stop offset="0.65524" stopColor="#925EFF" />
                      <stop offset="1" stopColor="#1A1EFF" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_23_13035"
                      x1="7.05241"
                      y1="4.34554"
                      x2="19.8074"
                      y2="5.23209"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FF9447" />
                      <stop offset="0.358383" stopColor="#FF64C1" />
                      <stop offset="0.65524" stopColor="#925EFF" />
                      <stop offset="1" stopColor="#1A1EFF" />
                    </linearGradient>
                  </defs>
                </svg>
                dcast
              </p>
              depend on your choice.
            </div>
          </div>
          {topOneCategoryPodcast?.length > 0 &&
            topOneCategoryPodcast?.map((podcast, i) => (
              <div
                onClick={() => router.push(`/view-podcast?id=${podcast?._id}`)}
                key={i}
                className="cursor-pointer lg:w-[300px] border rounded-md border-blue-500 m-2 p-2 shadow-blue-200 shadow-md"
              >
                <Image
                  width={600}
                  height={600}
                  className="w-full rounded h-[350px] lg:w-[335px] lg:h-[370px]"
                  src={`${
                    podcast?.picture?.path ? podcast?.picture?.path : "/"
                  }`}
                  alt="logo"
                />

                <p className="font-semibold text-2xl text-blue-600 my-5 pl-2 md:pl-5">
                  {podcast?.title}
                </p>

                <div className="flex gap-2 justify-around md:mb-5 text-base md:text-sm lg:text-base">
                  <p className="uppercase font-semibold">
                    Followers:{" "}
                    {formatCount(
                      podcast?.totalFollowers ? podcast?.totalFollowers : 0
                    )}
                  </p>
                  <p className="uppercase font-semibold">
                    Episodes: {podcast?.episodes?.length}
                  </p>
                </div>
              </div>
            ))}
        </div>

        {secondCategory?._id && (
          <div className="relative p-1 my-10">
            <p className="text-2xl md:text-3xl md:text-center text-blue-600 font-bold">
              {secondCategory?.name}
            </p>

            <button
              onClick={() => router.push(`/category?id=${secondCategory?._id}`)}
              className="absolute font-semibold flex gap-2 top-0 right-0 uppercase px-3 py-1 md:px-6 md:py-2 border border-black rounded-[50px] dark:text-white dark:border-white"
            >
              View All <FaLongArrowAltRight className="my-auto" />
            </button>
          </div>
        )}

        <div className="md:grid md:grid-cols-2 lg:grid-cols-4 gap-2 my-5 dark:text-white">
          {topTwoCategoryPodcast?.length > 0 &&
            topTwoCategoryPodcast?.map((podcast, i) => (
              <div
                onClick={() => router.push(`/view-podcast?id=${podcast?._id}`)}
                key={i}
                className="cursor-pointer lg:w-[300px] border rounded-md border-blue-500 m-2 p-2 shadow-blue-200 shadow-md"
              >
                <Image
                  width={600}
                  height={600}
                  className="w-full rounded h-[350px] lg:w-[335px] lg:h-[370px]"
                  src={`${
                    podcast?.picture?.path ? podcast?.picture?.path : "/"
                  }`}
                  alt="logo"
                />

                <p className="font-semibold text-2xl text-blue-600 my-5 pl-2 md:pl-5">
                  {podcast?.title}
                </p>

                <div className="flex gap-2 justify-around md:mb-5 text-base md:text-sm lg:text-base">
                  <p className="uppercase font-semibold">
                    Followers:{" "}
                    {formatCount(
                      podcast?.totalFollowers ? podcast?.totalFollowers : 0
                    )}
                  </p>
                  <p className="uppercase font-semibold">
                    Episodes: {podcast?.episodes?.length}
                  </p>
                </div>
              </div>
            ))}
        </div>

        <TrendingTopic category={category} />

        <div className="mb-10">
          <p className="text-3xl md:text-6xl text-center font-bold text-white py-5 bg-blue-500">
            Our Suggestions
          </p>
        </div>

        <div className="md:grid md:grid-cols-2 lg:grid-cols-3 gap-5 mb-20 p-2">
          {recommendationPodcasts &&
            recommendationPodcasts?.map((podcast, i) => (
              <div
                key={i}
                style={{ background: `url(${section.src})` }}
                className="relative h-auto !bg-no-repeat !bg-center !bg-cover z-10 rounded-xl mt-2 cursor-pointer"
              >
                <div className="absolute top-0 left-0 w-full h-full bg-[#5e5ec4]  opacity-90  dark:bg-[#2b2b92] -z-10 rounded-xl"></div>
                <div className="pt-44 pl-7 pr-11 text-white">
                  <p className="text-4xl font-bold">{podcast?.title}</p>
                  <p className="mt-10">{podcast?.description?.slice(0, 140)}</p>
                  <button
                    onClick={() =>
                      router.push(`/view-podcast?id=${podcast?._id}`)
                    }
                    className="uppercase px-5 py-3 font-semibold border-2 rounded-[50px] mt-5 mb-10"
                  >
                    Start Listening
                  </button>
                </div>
              </div>
            ))}
        </div>
      </section>
    </Layout>
  );
};

export default Home;
